import styled from 'styled-components';

const RemoveButton = styled.button`
  margin-left: 7px;
  left: 2px;
  position: relative;
  top: -2px;
  border: 1px solid #ccc;
  cursor: pointer;
  padding: 2px 15px;
  color: #444;
  border-radius: 3px;
`;

export default RemoveButton;



// WEBPACK FOOTER //
// ./src/components/RemoveButton.js